import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  employeeAwardList: {
    requesting: false,
    items: [],
    pagination: {
      current_page: 1,
      per_page: 10,
      total: 0,
    },
    filters: {},
    error: null,
    success: false,
  },

  employeeAwardDetails: {
    requesting: false,
    data: null,
    error: null,
    success: false,
  },
  dashboardStats: {
    requesting: false,
    data: null,
    error: null,
  }
}

export const employeeAwardSlice = createSlice({
  name: 'employeeAward',
  initialState,
  reducers: {

    getEmployeeAwardList: (state, action) => {
      state.employeeAwardList.requesting = true
      state.employeeAwardList.error = null
      state.employeeAwardList.success = false
      state.employeeAwardList.filters = action.payload
    },

    getEmployeeAwardListSuccess: (state, action) => {
      const { data, current_page, per_page, total } = action.payload

      state.employeeAwardList.requesting = false
      state.employeeAwardList.items = data || []
      state.employeeAwardList.success = true

      state.employeeAwardList.pagination.current_page = current_page
      state.employeeAwardList.pagination.per_page = per_page
      state.employeeAwardList.pagination.total = total
    },

    getEmployeeAwardListFail: (state, action) => {
      state.employeeAwardList.requesting = false
      state.employeeAwardList.error = action.payload
    },

    getEmployeeAwardDetails: (state) => {
      state.employeeAwardDetails.requesting = true
      state.employeeAwardDetails.error = null
      state.employeeAwardDetails.data = null
      state.employeeAwardDetails.success = false
    },

    getEmployeeAwardDetailsSuccess: (state, action) => {
      state.employeeAwardDetails.requesting = false
      state.employeeAwardDetails.data = action.payload
      state.employeeAwardDetails.success = true
    },

    getEmployeeAwardDetailsFail: (state, action) => {
      state.employeeAwardDetails.requesting = false
      state.employeeAwardDetails.error = action.payload
    },

    doEmployeeAwardCreate: (state) => {
      state.employeeAwardDetails.requesting = true
      state.employeeAwardDetails.error = null
      state.employeeAwardDetails.success = false
    },

    doEmployeeAwardCreateSuccess: (state, action) => {
      state.employeeAwardDetails.requesting = false
      state.employeeAwardDetails.data = action.payload
      state.employeeAwardDetails.success = true
    },

    doEmployeeAwardCreateFail: (state, action) => {
      state.employeeAwardDetails.requesting = false
      state.employeeAwardDetails.error = action.payload
      state.employeeAwardDetails.success = false
    },

    doEmployeeAwardUpdate: (state) => {
      state.employeeAwardDetails.requesting = true
    },

    doEmployeeAwardUpdateSuccess: (state, action) => {
      state.employeeAwardDetails.requesting = false
      state.employeeAwardDetails.data = action.payload
      state.employeeAwardDetails.success = true
    },

    doEmployeeAwardUpdateFail: (state, action) => {
      state.employeeAwardDetails.requesting = false
      state.employeeAwardDetails.error = action.payload
      state.employeeAwardDetails.success = false
    },

    doEmployeeAwardDelete: (state) => {
      state.employeeAwardDetails.requesting = true
      state.employeeAwardDetails.error = null
    },

    doEmployeeAwardReset: (state) => {
      state.employeeAwardDetails.data = null
      state.employeeAwardDetails.error = null
      state.employeeAwardDetails.success = false
    },

    getEmployeeAwardDashboard: (state) => {
      state.dashboardStats.requesting = true
      state.dashboardStats.error = null
    },

    getEmployeeAwardDashboardSuccess: (state, action) => {
      state.dashboardStats.requesting = false
      state.dashboardStats.data = action.payload
    },

    getEmployeeAwardDashboardFail: (state, action) => {
      state.dashboardStats.requesting = false
      state.dashboardStats.error = action.payload
    },
    
  },
})

export const {
  getEmployeeAwardList, getEmployeeAwardListSuccess,
  getEmployeeAwardListFail, getEmployeeAwardDetails,
  getEmployeeAwardDetailsSuccess, getEmployeeAwardDetailsFail, 
  doEmployeeAwardCreate, doEmployeeAwardCreateSuccess, 
  doEmployeeAwardCreateFail, doEmployeeAwardUpdate, 
  doEmployeeAwardUpdateSuccess, doEmployeeAwardUpdateFail, 
  doEmployeeAwardDelete, doEmployeeAwardReset,
  getEmployeeAwardDashboard, getEmployeeAwardDashboardSuccess,
  getEmployeeAwardDashboardFail
} = employeeAwardSlice.actions

export default employeeAwardSlice.reducer